exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".callout-panel {\n  font-size: 0.9rem;\n  margin: 30px 0;\n  text-align: center; }\n\n.callout-panel p {\n  margin: 2px 0; }\n\n.callout-panel-icon {\n  width: 80px;\n  height: 80px;\n  margin-bottom: 20px; }\n\n.callout-panel-icon i {\n  margin-top: 10px; }\n\n.callout-message {\n  margin-bottom: 40px; }\n\n.callout-message span {\n  text-transform: lowercase; }\n\n.project {\n  color: #4285f4;\n  font-size: 80px; }\n\n.analysis-ok {\n  background: #00E676;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 60px; }\n\nbutton {\n  margin: 0 1px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/new-route/components/create-success/create-success.component.scss
// module id = 1293
// module chunks = 0